// A generation identifies the account context that started asynchronous work.
// Invalidating it immediately stops late responses from populating new state.
let user: string | null | undefined;
let generation = 0;
const listeners = new Set<() => void>();

export function identityUser(): string | null | undefined { return user; }
export function identityGeneration(): number { return generation; }
export function selectIdentity(next: string | null): void {
  if (next === user) return;
  user = next;
  generation++;
  for (const listener of listeners) listener();
}
export function onIdentityChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
export function requireGeneration(expected: number): void {
  if (expected !== generation) throw new Error('The signed-in account changed; reload this page.');
}
